import { BasicClient } from '@/utils/httpClient';

export default class Actions {
    client;
    constructor() {
        this.client = new BasicClient();
    }
    getActions() {
      return this.client.exec('/actions/available', 'GET');
      }
}